import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import useLocalStorage from './useLocalStorage';

const useSearchParams = (key, initialValue, validate = () => true) => {

    const history = useHistory();
   const [storedValue, setStoredValue] = useLocalStorage(key, { locale: initialValue }, true);
    let historySearch = history.location.search;

    const [paramValue, setParamValue] = useState(() => {
        try {
            let arrayLocationSearch = historySearch.replace('?', '')?.split('&');
            let historyLocale = arrayLocationSearch?.find((e) => e.startsWith(key))?.split('=')[1];

            if (historyLocale !== undefined && validate(historyLocale)) {
                setStoredValue({ locale: historyLocale });
                return historyLocale;
            };

            let parsedValue = validate(storedValue.locale) ? storedValue.locale : initialValue;
            setStoredValue({ locale: parsedValue })
            updateSearchParams(history, key, parsedValue);
            return parsedValue;
        } catch (error) {
            console.log(error);
        }
    });


    const setValue = value => {
        try {
            setParamValue(currentValue => {
                if (!value || currentValue === value) {
                    setStoredValue({ locale: currentValue });
                    return currentValue;
                }
                setStoredValue({ locale: value });
                updateSearchParams(history, key, value);
                return value;
            });
        } catch (error) {
            console.log(error);
        }
    };

    return [paramValue, setValue];
};


function updateSearchParams(history, key, value) {
    const queryString = `${key}=${value}`;

    if (!history) return;
    let historySearch = history?.location?.search;

    let arrayLocationSearch = historySearch?.replace('?', '').split('&') || [];
    let lang = arrayLocationSearch?.find((e) => e.startsWith(key));

    if (lang) {
        let langIndex = arrayLocationSearch.indexOf(lang);
        arrayLocationSearch[langIndex] = queryString;
    }
    else {
        arrayLocationSearch.push(queryString);
    }

    let locationSearch;

    if (historySearch)
        locationSearch = arrayLocationSearch.join('&');
    else
        locationSearch = arrayLocationSearch.join('');

    locationSearch = '?' + locationSearch;

    history.replace(locationSearch);
}

export default useSearchParams;
